import styled from 'styled-components';

interface ISize {
  height?: string;
  width?: string;
}

interface ICollapsed {
  collapsed?: boolean;
}

export const SpacedContent = styled.div`
  width: 100%;
  margin-bottom: 1rem;
`;

export const LeftAlignedContent = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  align-items: flex-start;
  width: 100%;
  margin-top: 2rem;
`;

export const CenteredContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const CollapsibleContent = styled.div<ICollapsed>`
  display: ${props => (props.collapsed ? 'none' : 'visible')};
  width: 100%;
`;

export const PlacementHolder = styled.div<ISize>`
  height: ${p => p.height};
  width: ${p => p.width};
`;

export const FormSection = styled.div`
  margin: 1rem 0 1rem;
`;

export const SuccessHeading = styled.h4`
  color: #432726;
  font-size: 2rem;
  font-weight: ${Styles.fontWeight.heavy};
  letter-spacing: -1.13px;
  line-height: 1.14;
  margin: 1.5rem 0 0.75rem;
`;

export const SectionHeading = styled.h4`
  margin-bottom: 0;
  margin-top: 1.5rem;
`;

export const SubheadingButton = styled.button`
  width: 100%;
  background-color: transparent;
  border: none;
  color: ${Styles.color.secondary};
  font-size: 1.25rem;
  font-weight: bold;
  font-family: ${Styles.fontFamily.base};
  margin: 0;
  padding: 0.75rem 0;
  text-align: left;
  text-transform: capitalize;
`;

export const DisplayToggle = styled.div`
  position: absolute;
  right: 1.55rem;
  top: 1.15rem;
  pointer-events: none;
  z-index: ${Styles.zIndex.normal};
`;

export const SubheadingContainer = styled.div`
  position: relative;
  width: 100%;
  border-bottom: 1px solid #cac2c2;
`;

export const TimCardText = styled.h4`
  font-family: ${Styles.fontFamily.base};
  font-weight: ${Styles.fontWeight.normal};
  font-size: 2rem;
  color: ${Styles.color.primary};
  line-height: 35%;
  margin: 0.5rem 0 1.5rem;
  text-align: center;
`;

export const NormalText = styled.p`
  font-size: 1rem;
  line-height: 1.56;
  margin: 0 1rem;
  color: #432726;
  font-family: ${Styles.fontFamily.base};
  text-align: center;
`;

export const InstructionText = styled.p`
  font-size: 1rem;
  text-align: center;
  margin-bottom: 0;
`;

export const SubInstructionText = styled.p`
  font-size: 0.875rem;
  opacity: 0.7;
`;

export const ErrorAnchor = styled.a`
  color: ${Styles.color.primary};
`;

export const ButtonContainer = styled.div`
  width: 100%;
  margin: 2rem 0;
`;

export const SectionDescription = styled.p`
  line-height: 1.5rem;
  margin: 1rem 0;
  padding-bottom: 0.5rem;
`;
